const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.talabatn.net';
export const fileUrl = process.env.REACT_APP_FILE_URL || 'https://file.talabatn.net';

export const SIGN_UP_API = `${BASE_URL}/iam/oauth2/sign_up`;
export const SIGN_IN_API = `${BASE_URL}/iam/oauth2/sign_in`;
export const apiUrl = `${BASE_URL}/content`;
export const productsApiUrl = `${BASE_URL}/marketplace`;
export const fileHandlerUrl = `${BASE_URL}/file_handler`;
export const publicUrl = process.env.PUBLIC_URL + '/';